module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_8.e3d732fd.jpg";